module.exports = __webpack_public_path__ + "img/热门商品.png";